import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { APP_ENDPOINTS } from 'app/endpoints';
import { PromotionDto } from '../types/dtos';

export default (builder: EndpointBuilder<BaseQueryFn, string, string>) =>
    builder.mutation<void, { id: string; payload: Partial<PromotionDto> }>({
        query: ({ id, payload }) => ({
            url: `${APP_ENDPOINTS.PROMOTION}/${id}`,
            method: 'PATCH',
            body: payload,
        }),
        invalidatesTags: [
            { type: 'promotion', id: 'GET-ID' },
            { type: 'promotions', id: 'GET' },
        ],
    });
